import { k } from "../i18n/i18n";

/** Libellés de l'IA sans nom de machine ni de modèle (R15). Le serveur nomme la source d'une réponse et l'adresse
 *  injoignable d'une erreur par un libellé technique (« serveur GPU (modèle avancé) », « serveur GPU (modèle
 *  Generex) », « IA de secours », et le poste IA du Mac tant qu'il est configuré : « poste IA (Mac, modèle Generex
 *  avancé) ») ; l'interface n'en garde que le rôle : modèle rapide ou avancé, IA de secours (registre E27). */

/** Rôle de la source d'une réponse (libellé serveur, en français) : clé française à traduire par `t()`. */
export function aiSourceKey(source: string): string {
  if (source.startsWith("serveur GPU") || source.startsWith("poste"))
    return source.includes("avancé") ? k("modèle avancé") : k("modèle rapide");
  return k("IA de secours");
}

/** Libellés techniques d'un message d'erreur déjà traduit (`tServer`), en français comme en anglais, ramenés au
 *  rôle : « serveur GPU », « GPU server », « poste IA », « AI workstation », « serveur de secours », « fallback
 *  server » (anciens libellés). */
const PLAIN: [RegExp, string][] = [
  [/serveur GPU \([^()]*\)/g, "serveur GPU"],
  [/GPU server \([^()]*\)/g, "GPU server"],
  [/poste IA \(Mac[^()]*\)/g, "poste IA"],
  [/AI workstation \(Mac[^()]*\)/g, "AI workstation"],
  [/serveur \(CPU[^()]*\)/g, "serveur de secours"],
  [/server \(CPU[^()]*\)/g, "fallback server"],
];

export function plainAiText(text: string): string {
  return PLAIN.reduce((out, [pattern, plain]) => out.replace(pattern, plain), text);
}
